const debug = true
const allList = ["af","sq","am","ar","hy","az","bn","bs","bg","ca","zh","zh-Hant","hr","cs","da","nl","et","en","fa","fil","fi","fr","ka","de","el","gu","ht","ha","he","hi","hu","is","id","ga","it","ja","kn","kk","ko","lv","lt","mk","ms","ml","mt","mr","mn","no","ps","pl","pt","pa","ro","ru","sr","si","sk","sl","so","es","sw","sv","ta","te","th","tr","uk","ur","uz","vi","cy", "sq"]

export default {
	debug: debug,
	home: debug ? "https://dev-www.japanesepal.com" : "https://www.japanesepal.com",
	domain: debug ? "https://dev-talk.japanesepal.com" : "https://talk.japanesepal.com",
	host: debug ? "https://dev-api.japanesepal.com/" : 'https://api.japanesepal.com/',
	package: 'calteacher',
	requestVersion: "2.2.0",
	platform: "web",
	version: '2.2.0',
	base: debug ? "https://d3ljvp8zxci06.cloudfront.net/" : "https://dt1693bd6sdrf.cloudfront.net/",
	allList: allList,
	googleClientID: "1045537298793-76ql0h170ragj5oiiposeldudgl6p66m.apps.googleusercontent.com",
	appleClientID: "com.japanesepal.web"
}
